"use client";

import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/app/components/ui/alert-dialog";
import Link from "next/link";

interface HybridInfoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm?: () => void;
  liveClose: boolean;
}

const liveCloseContent: React.ReactNode = (
  <>
    This sale is a hybrid auction. The interface will display only the lot that the auctioneer is currently calling. Each lot is closed at the auctioneer&apos;s discretion and all bidders (in-person and online) will get a <strong>clear warning</strong> before a lot is closed. Max bids are disabled during hybrid auctions and only standard bids are allowed.
  </>
);
const activeBiddingContent: React.ReactNode = (
  <>
    This sale is a hybrid auction and bidding is currently online. During closing, the display will switch to the single lot the auctioneer is calling. Each lot is closed at the auctioneer&apos;s discretion and all bidders (in-person and online) will get a clear <strong>warning</strong> before a lot is closed. Max bids are disabled during hybrid auctions and only standard bids are allowed.
  </>
);

const HybridInfoDialog: React.FC<HybridInfoDialogProps> = ({ open, onOpenChange, onConfirm, liveClose = false }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Hybrid Auction Notice</AlertDialogTitle>
          <AlertDialogDescription className="text-foreground/80">
            {liveClose ? liveCloseContent : activeBiddingContent}

            <br /><br />

            To learn more about hybrid auctions, please visit our <Link href="/hybrid-auction" className="text-blue-600 font-semibold">info page</Link>.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={() => { onOpenChange(false); onConfirm?.(); }}>Bid now</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default HybridInfoDialog;


